import { render, staticRenderFns } from "./WebhotelList.vue?vue&type=template&id=55c89838&scoped=true"
import script from "./WebhotelList.vue?vue&type=script&lang=js"
export * from "./WebhotelList.vue?vue&type=script&lang=js"
import style0 from "./WebhotelList.vue?vue&type=style&index=0&id=55c89838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c89838",
  null
  
)

export default component.exports